<template>
  <article class="gs-product-card">
    <button
      type="button"
      class="gs-product-card__media"
      :aria-label="`Edit ${product.name}`"
      @click="sendToEditProduct"
    >
      <img
        v-if="productImage"
        class="gs-product-card__image"
        :src="productImage"
        :alt="product.name"
      />
      <gifts-icon v-else class="gs-product-card__placeholder" />
      <span class="gs-product-card__edit">{{ $t('frontend_product_edit') }}</span>
    </button>
    <div class="gs-product-card__body">
      <div class="gs-product-card__badges">
        <span v-if="product.is_test_mode_enabled" class="gs-product-card__badge is-warning">
          {{ $t('frontend_groove_sell_span_test_mode') }}
        </span>
        <span class="gs-product-card__badge">{{ productTypeName }}</span>
      </div>
      <div class="gs-product-card__title-row">
        <h3>{{ product.name }}</h3>
        <drop-menu :menu-items="menuItems" dropMenuClass="absolute bottom-0 mt-13 z-40" small></drop-menu>
      </div>
      <p class="gs-product-card__meta">{{ product.internal_name || 'No internal name' }}</p>
      <div class="gs-product-card__actions">
        <button
          v-for="option in menuItemsIcons"
          :key="option.text"
          type="button"
          class="gs-product-card__icon-button"
          :aria-label="option.text"
          :title="option.text"
          @click="option.callback()"
          v-tooltip="option.text"
        >
          <component :is="option.icon" />
        </button>
      </div>
    </div>
  </article>
</template>

<script>
import ChartBarIcon from '@/assets/images/icons/ChartBarIcon.svg';
import PencilIcon from '@/assets/images/icons/PencilIcon.svg';
import ShoppingCartIcon from '@/assets/images/icons/ShoppingCartIcon.svg';
import CloneIcon from '@/assets/images/icons/CloneIcon.svg';
import MegaphoneIcon from '@/assets/images/icons/MegaphoneIcon.svg';
import GiftsIcon from '@/assets/images/icons/GiftsIcon.svg';

export default {
  name: 'ProductGridAsset',
  components: {
    GiftsIcon,
  },
  props: {
    product: {},
    productType: {},
    admin: {
      default: false,
    },
    funnel: {},
  },
  computed: {
    productTypeName() {
      let productTypeName = '';

      if (this.productType != 'atc_order_bumps') {
        if (this.product.type == 1) productTypeName = this.$t('frontend_groovesell_tag_frontend');
        if (this.product.type == 2) productTypeName = this.$t('frontend_product_index_tab_upsell_downsell');
        if (this.product.type == 3) productTypeName = this.$t('frontend_product_step1_order_bump');
      } else {
        productTypeName = this.$t('upsell_add_to_cart_order_bumps');
      }

      return productTypeName;
    },
    productImage() {
      let hasImage = false;

      if (
        this.product.checkout_page_options &&
        this.product.checkout_page_options != null &&
        this.product.checkout_page_options.product_image &&
        this.product.checkout_page_options.product_image != ''
      )
        hasImage = this.product.checkout_page_options.product_image;

      return hasImage;
    },
    isProductComplete() {
      let productComplete = true;
      if (this.product.is_wizard_complete && this.product.is_complete) {
        productComplete = false;
      }
      return productComplete;
    },
    menuItemsIcons() {
      const menuItemsIcons = [];
      menuItemsIcons.push({
        icon: PencilIcon,
        text: this.$t('frontend_product_edit'),
        callback: () =>
          this.$emit('onProductEdit', this.product.id, this.isProductComplete),
      });
      if (this.productType != 'atc_order_bumps') {
        menuItemsIcons.push({
          icon: ShoppingCartIcon,
          text: this.$t('forntend_checkout_links'),
          callback: () => this.$emit('onProductCheckOutLinks', this.product.id),
        });
      }
      if (this.admin && this.productType != 'atc_order_bumps') {
        menuItemsIcons.push({
          icon: ChartBarIcon,
          text: this.$t('frontend_groovesell_menu_items_projections'),
          callback: () => this.$emit('onProductProjection', this.product.id),
        });
      }
      if (this.productType != 'atc_order_bumps') {
        menuItemsIcons.push({
          icon: CloneIcon,
          text: this.$t('frontend_groovesell_menu_items_clone_product'),
          callback: () => this.$emit('onProductClone', this.product.id),
        });
      }
      menuItemsIcons.push({
        icon: MegaphoneIcon,
        text: this.$t('frontend_funnels_affiliate_signup_promo_tools'),
        callback: () => this.$emit('onManagePromotools', this.funnel.id),
      });
      return menuItemsIcons;
    },
    menuItems() {
      const menuItems = [];
      if (this.productType != 'atc_order_bumps') {
        if (!this.product.is_test_mode_enabled) {
          menuItems.push({
            text: this.$t('frontend_groovesell_menu_items_enable_test_mode'),
            callback: () =>
              this.$emit('onProductEnableTestMode', this.product.id, 1),
          });
        } else {
          menuItems.push({
            text: this.$t('frontend_groovesell_menu_items_disable_test_mode'),
            callback: () =>
              this.$emit('onProductEnableTestMode', this.product.id, 0),
          });
        }
      }
      if (this.productType != 'atc_order_bumps') {
        menuItems.push({
          text: this.$t('frontend_groovesell_menu_items_tracking_links'),
          callback: () => this.$emit('onProductTracking', this.product.id),
        });
      }
      if (this.product.is_main != true) {
        menuItems.push({
          text: this.$t('frontend_groovesell_menu_items_delete_product'),
          callback: () => this.$emit('onProductDelete', this.product.id),
        });
      }
      if (
        this.productType == 'all' &&
        !this.product.hasOwnProperty('is_main')
      ) {
        const Trackingindex = menuItems.findIndex(
          (x) => x.text == this.$t('frontend_groovesell_menu_items_tracking_links')
        );
        menuItems.splice(Trackingindex, 1);
        const checkOutLinkindex = menuItems.findIndex(
          (x) => x.text == this.$t('forntend_checkout_links')
        );
        menuItems.splice(checkOutLinkindex, 1);
        const cloneindex = menuItems.findIndex(
          (x) => x.text == this.$t('frontend_product_clone')
        );
        menuItems.splice(cloneindex, 1);
      }

      return menuItems;
    },
  },
  methods: {
    backgroundImageUrl(url) {
      if (url) {
        return `url("${url}")`;
      }

      return '';
    },
    sendToEditProduct() {
      this.$emit('onProductEdit', this.product.id, this.isProductComplete);
    },
  },
};
</script>

<style lang="scss">
.gs-product-card {
  display: flex;
  flex-direction: column;
  min-height: 282px;
  margin: 8px 0 14px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e4e8f1;
  border-radius: 8px;
  box-shadow: 0 14px 32px rgba(31, 37, 72, .07);
  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
}

.gs-product-card:hover {
  border-color: #ffc4d1;
  box-shadow: 0 22px 44px rgba(31, 37, 72, .12);
  transform: translateY(-2px);
}

.gs-product-card__media {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
  padding: 22px;
  color: #ff5b7f;
  background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);
  border: 0;
  border-bottom: 1px solid #edf0f6;
  cursor: pointer;
}

.gs-product-card__image,
.gs-product-card__placeholder {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 12px 18px rgba(31, 37, 72, .12));
}

.gs-product-card__placeholder {
  fill: currentColor;
}

.gs-product-card__edit {
  position: absolute;
  inset: auto 14px 14px;
  padding: 9px 12px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 650;
  text-align: center;
  background: #ff5b7f;
  border-radius: 6px;
  box-shadow: 0 12px 24px rgba(255, 91, 127, .28);
  opacity: 0;
  transform: translateY(8px);
  transition: opacity .18s ease, transform .18s ease;
}

.gs-product-card:hover .gs-product-card__edit {
  opacity: 1;
  transform: translateY(0);
}

.gs-product-card__body {
  display: grid;
  gap: 7px;
  padding: 14px 16px 16px;
}

.gs-product-card__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.gs-product-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 4px 7px;
  color: #ff5b7f;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
  background: #fff5f7;
  border-radius: 6px;
}

.gs-product-card__badge.is-warning {
  color: #b77a00;
  background: #fff0c9;
}

.gs-product-card__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.gs-product-card__title-row h3 {
  min-height: 36px;
  margin: 0;
  color: #171b3f;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.28 !important;
}

.gs-product-card__meta {
  min-height: 20px;
  margin: 0;
  overflow: hidden;
  color: #7c849c;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gs-product-card__actions {
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
}

.gs-product-card__icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  color: #5f6884;
  background: #f7f8fc;
  border: 1px solid #e4e8f1;
  border-radius: 6px;
}

.gs-product-card__icon-button:hover {
  color: #ff5b7f;
  background: #fff5f7;
  border-color: #ffc4d1;
}

.gs-product-card__media:focus-visible,
.gs-product-card__icon-button:focus-visible {
  outline: 3px solid rgba(255, 91, 127, .3);
  outline-offset: -3px;
}

.gs-product-card__icon-button svg {
  width: 16px;
  height: 16px;
  fill: currentColor;
}
</style>
